export const ADMIN_SIDEBAR_CONSTANTS = {
    ITEM_HEIGHT: 72,
    PADDING_BUFFER: 16, 
    MIN_ITEMS: 1, 
    
    RESIZE_DEBOUNCE_DELAY: 100, 
    INITIAL_CALCULATION_DELAY: 100, 
    
    FAST_PAGE_JUMP: 10, 
    
    TITLE: 'Administration Users',
    SEARCH_PLACEHOLDER: 'Search Administration Users...',
    CREATE_ADMIN_BUTTON: 'CREATE ADMINISTRATOR USER',
    DELETE_ADMIN_BUTTON: 'DELETE ADMINISTRATOR USER',
    
    PAGINATION_BUTTON: {
      MIN_WIDTH: '40px',
      PADDING_X: '10px'
    },
    
    AVATAR: {
      WIDTH: 40,
      HEIGHT: 40,
      MARGIN_RIGHT: 1
    },
    
    SIDEBAR_WIDTH: '400px',
    MIN_WIDTH: '400px',
    LIST_HEIGHT: '50vh'
  } as const;